export class SubEventCodeModel {
	constructor(readonly value : string) {
	}
}



// WEBPACK FOOTER //
// ./src/app/models/subeventcode-model.ts